import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PromotionType } from "../../../interfaces/promotionType";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";
import { promotionApi } from "../services/promotion.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PROMOTION_MESSAGES_ERROR,
  PROMOTION_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useSavePromotionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<PromotionType>, Error, PromotionType>({
    mutationFn: (promotion) => promotionApi.savePromotion(promotion),
    onSuccess: (res, variables) => {
      if (!res.ok) {
        errorNotification(PROMOTION_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(PROMOTION_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["promotions"] });
      if (variables._id) {
        queryClient.invalidateQueries({
          queryKey: ["promotion-by-id", variables._id],
        });
      }
    },
    onError: () => {
      errorNotification(PROMOTION_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
